<template>
<div>
    <v-snackbar
      outlined
      v-model="snackbar"
      absolute="absolute"
      :bottom="verticalAlign === 'bottom'"
      :color="color"
      :left="horizontalAlign === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="horizontalAlign === 'right'"
      :timeout="timeout || 60000"
      :top="verticalAlign === 'top'"
      :vertical="mode === 'vertical'"
      @click="snackbar = false"
    >
      {{ text }}
      
      <template v-slot:action="">
        <v-icon
         color="color"
         @click="close">
          mdi-close-circle-outline
        </v-icon>
      </template>
    </v-snackbar>
</div>
</template>
<script>
export default {
    name:'Snackbar',
    props:['text','color', 'timeout', 'mode'],
    data() {
        return {
            horizontalAlign: null,
            verticalAlign: 'top'
        };
    },
    computed:{
        snackbar: {
            get() {
                return this.$store.state.showSnackbar;
            },
            set(value) {
                this.$store.commit('updateShowSnackbar', value);
            }
        }
    },
    methods: {
        close() {
            this.snackbar = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.v-snack--absolute {
  /*position: fixed;*/
}
.v-snack--top {
  /*top: 30%;*/
}
</style>